import IcTableFilter from './IcTableFilter'

export default IcTableFilter
